<template>
  <div>

    <a role="button" class="btn btn-primary" href="#"  @click="btnSelectItemsObjects">SelectItems Objects</a>
    <a role="button" class="btn btn-primary" href="#"  @click="btnSelectItemsSystemIds">SelectItems SystemIds</a>
    <a role="button" class="btn btn-primary" href="#"  @click="btnExportExcel">export excel</a>

    <br>
    <a role="button" class="btn btn-primary" href="#"  @click="btnEnableFilter">Enable Filter</a>
    <a role="button" class="btn btn-primary" href="#"  @click="btnColumnAutoResize">Enable ColumnAutoResize</a>

    <MyGridKendo ref="grid" :columns="gridDefine.columns" :datas="gridDefine.datas" style="width:1024px"></MyGridKendo>
  </div>
</template>

<script>
import MyGridKendo from "@/views/taylorAdmin/component/MyGridKendo";
/**

 **/


export default {
  components: {MyGridKendo},
  data: function () {
    return {
      gridDefine:{
        columns: [
          // { field: 'SystemId', title: 'SystemId', minWidth: 50, width: '50px'},
          { field: 'fun', title: '功能' ,width:100, filterable:false, cell: this.cellFunctionLink},
          { field: 'LoginId', title: '登入帳號' ,width:200},
          { field: 'Name', title: '姓名' ,width:200},
          { field: 'Email', title: 'Email' ,width:300},
          { field: 'Tel', title: '電話' ,width:100},
            //other minWidth: 100,filterable:false
        ],
        datas:[],
      },
    };
  },

  methods: {
    cellFunctionLink: function (h, tdElement , props, clickHandler ) {  // eslint-disable-line
      let that=this;
      let clickFun=function(){
        // that.gotoWithSystemId('MemberEdit',props.dataItem.SystemId)
        alert('click')
      }

      //---------------------------------------
      return h('td', {
        on: {
          click: function(e){// eslint-disable-line
            clickFun();
          }
        },
        domProps: {
          innerHTML: '<a class="btn btn-primary" href="#"><i class="fa fa-pen"></i></a>'
        }
      });
    },
    async loadData() {
      let datas=[
        {
          "SystemId": "1",
          "LoginId": "test1",
          "Name": "test1",
          "Email": "email1"
        },
        {
          "SystemId": "2",
          "LoginId": "test2",
          "Name": "test2",
          "Email": "email2"
        },
      ];

      this.gridDefine.datas=datas;
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    btnSelectItemsObjects(){
      alert(this.$refs.grid.selectedItemsObjects());
    },
    btnSelectItemsSystemIds(){
      alert(this.$refs.grid.selectedItemsSystemIds());
    },
    btnExportExcel(){
      this.$refs.grid.exportExcel();
    },
    btnEnableFilter(){
      this.$refs.grid.setting_enableFilter(false);
    },
    btnColumnAutoResize(){
      this.$refs.grid.setting_columnAutoResize(true);
    },
  },
  mounted() {
    // this.initValue()
    this.loadData()
  },
}
</script>

<style scoped>

</style>
